/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, seats: NonNullable<unknown>, people: NonNullable<unknown> }} Receipt_Minimum_WhenInputs */



/**
* | output |
* | --- |
* | "{range}: the plan bills at least {seats} seats; the organization had {people} people." |
*
* @param {Receipt_Minimum_WhenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_minimum_when = /** @type {((inputs: Receipt_Minimum_WhenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Minimum_WhenInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.range}: Der Tarif berechnet mindestens ${i?.seats} Plätze; die Organisation hatte ${i?.people} Personen.`)
	return /** @type {LocalizedString} */ (`${i?.range}: the plan bills at least ${i?.seats} seats; the organization had ${i?.people} people.`)
});